import zustand from "zustand";
import {devtools, persist} from "zustand/middleware";

export type SettingsStoreProps = {
  navbarExtended: boolean,
  userbarExtended: boolean,
  toggleNavbar: () => void,
  toggleUserbar: () => void,
}
export const useSettingStore = zustand<SettingsStoreProps>()(
  devtools(persist(
    (set, get) => ({
      navbarExtended: true,
      toggleNavbar: () => set((old) => ({navbarExtended: !old.navbarExtended})),
      userbarExtended: false,
      toggleUserbar: () => set((old) => ({userbarExtended: !old.userbarExtended})),
    }),
    {
      name: "settings-store",
    }
  ))
)
